export default __webpack_public_path__ + "static/media/ziplining1.95031062.webp";